import React from 'react';
import cx from 'classnames';
import Tag from '../tag';
import '../tag/style';
var clsPrefix = 'tcpc-region-item';

var RegionItem = function RegionItem(props) {
  var className = props.className,
      style = props.style,
      _onClick = props.onClick,
      data = props.data,
      selectedId = props.selectedId,
      size = props.size;
  var baseProps = {
    style: style,
    className: cx(clsPrefix, className, "".concat(clsPrefix, "-").concat(size))
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-list")
  }, Object.keys(data).length !== 0 && Object.keys(data).map(function (v) {
    return /*#__PURE__*/React.createElement("div", {
      key: v,
      className: "".concat(clsPrefix, "-item")
    }, /*#__PURE__*/React.createElement("label", {
      className: "".concat(clsPrefix, "-label")
    }, v), Array.isArray(data[v]) && data[v].map(function (vv) {
      return /*#__PURE__*/React.createElement(Tag, {
        className: "".concat(clsPrefix, "-district"),
        onClick: function onClick() {
          return _onClick && _onClick(vv);
        },
        selected: vv.id === selectedId,
        style: {
          color: '#999999'
        },
        key: vv.id
      }, vv.name, "\uFF08", vv.total, "\uFF09");
    }));
  })));
};

RegionItem.defaultProps = {
  selectedId: -1,
  size: 'large'
};
export default /*#__PURE__*/React.memo(RegionItem);